import { useId } from 'react';
import { isHexColor } from '../brand-colors';

/** Shared color control: picker + editable hex, with named help/error states. */
export function ColorField({ label, value, onChange, onPick = onChange, help, error, notice, disabled = false }: {
  label: string; value: string; onChange: (value: string) => void; onPick?: (value: string) => void;
  help?: string; error?: string; notice?: string; disabled?: boolean;
}) {
  const id = useId();
  return <div className="color-field">
    <label htmlFor={id}>{label}</label>
    <div className="color-field__controls">
      <input className="control-color" type="color" aria-label={`Choose ${label.toLowerCase()}`} value={isHexColor(value) ? value : '#000000'} disabled={disabled}
        aria-describedby={`${id}-help`} onChange={(event) => onPick(event.target.value.toUpperCase())} />
      <input id={id} value={value} maxLength={7} spellCheck={false} autoCapitalize="characters" autoComplete="off" disabled={disabled}
        aria-invalid={!!error} aria-describedby={`${id}-help`} onChange={(event) => onChange(event.target.value)} />
    </div>
    <small id={`${id}-help`} className={error ? 'color-field__error' : 'form-help'} aria-live="polite">{error || notice || help}</small>
  </div>;
}
